import { Typography } from "@mui/material";
import { NextPage } from "next";
import { LoginLayout } from "../layouts/pages/LoginLayout";
import classes from "./signup.module.scss";

const Signup: NextPage = () => {
  return (
    <LoginLayout
      title="Sign up"
      displayLoginButton
      officeNotice
      displaySSO={false}
      googleBtnText={`Connect your Google work\xa0account`}
      displayPreview
      hideBanner
      classes={{ wrapper: classes.wrapper }}
    >
      <Typography variant="h1" className={classes.heading}>
        Welcome to Reclaim.ai
      </Typography>
      <Typography variant="subtitle2" component="p" className={classes.subtitle}>
        Create your free account — no credit card&nbsp;required
      </Typography>
    </LoginLayout>
  );
};

export default Signup;
